/* eslint-disable react/no-deprecated */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Text, NumberInput, LsaCategoriesModal, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { numberWithCommas } from '../../../services/helpers.js';
import { updateFormField } from '../../../actions/signup.js';
import Tip from '../../../components/Tip.js';
import { calculateProratedBalances } from '../../SpendingAccounts/getProratedQuarterlyBalances.js';

class SpendingAccounts extends PureComponent {
    state = {
        hsaAmount: this.props.initData.pooledAmountAvailable,
        lsaAmount: 0,
        amountAvailable: this.props.initData.pooledAmountAvailable,
        proratedHsa: 0,
        proratedLsa: 0,
        showLsaItemsModal: false
    };

    _calculateProratedBalances = () => {
        const { hsaAmount, lsaAmount } = this.state;
        let { eligibilityDate, proratedBy, isQuarterlyAllowance } = this.props.initData;
        const { proratedHsa, proratedLsa } = calculateProratedBalances(eligibilityDate, proratedBy, hsaAmount, lsaAmount, isQuarterlyAllowance);

        this.setState({
            proratedHsa,
            proratedLsa
        });
    };

    componentDidMount() {
        this.setState({
            hsaAmount: this.props.hsaAmount || this.props.initData.pooledAmountAvailable,
            lsaAmount: this.props.lsaAmount || 0
        });

        if (this.props.initData.isProrated) {
            this._calculateProratedBalances();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            hsaAmount: nextProps.hsaAmount || this.props.initData.pooledAmountAvailable,
            lsaAmount: nextProps.lsaAmount || 0
        });
    }

    _onBlur = () => {
        this.props.dispatch(updateFormField('spendingAccounts', 'hsaAmount', this.state.hsaAmount));
        this.props.dispatch(updateFormField('spendingAccounts', 'lsaAmount', this.state.lsaAmount));
    };

    _handleHsaChange = async (value) => {
        // make the saved state to false, since we have made edits
        this.props.setSavedState('spendingAccounts', false);

        const amountAvailable = this.state.amountAvailable;
        const diff = amountAvailable - value;

        await this.setState({
            hsaAmount: value,
            lsaAmount: diff
        });

        if (this.props.initData.isProrated) {
            this._calculateProratedBalances();
        }
    };

    _handleLsaChange = async (value) => {
        // make the saved state to false, since we have made edits
        this.props.setSavedState('spendingAccounts', false);

        const amountAvailable = this.state.amountAvailable;
        const diff = amountAvailable - value;

        await this.setState({
            lsaAmount: value,
            hsaAmount: diff
        });

        if (this.props.initData.isProrated) {
            this._calculateProratedBalances();
        }
    };

    _validateForm = () => {
        let hsaAmountError = false;
        let lsaAmountError = false;

        const hsaAmount = Number(`${ this.state.hsaAmount }`.replace(',', ''));
        const lsaAmount = Number(`${ this.state.lsaAmount }`.replace(',', ''));

        if (hsaAmount + lsaAmount !== this.props.amountAvailable) {
            // eslint-disable-next-line no-multi-assign
            hsaAmountError = lsaAmountError = i18n.t(tokens.labels.spendingAccounts.ensureMaximumEqualsAvailable);
        }

        this.setState({
            hsaAmountError,
            lsaAmountError
        });

        if (
            hsaAmountError ||
            lsaAmountError
        ) {
            return false;
        }

        return true;
    };

    _next = () => {
        // make the saved state to true, we have hit next and everything is valid
        this.props.setSavedState('spendingAccounts', true);

        this.props.stepCompletion(
            {
                hsaAmount: this.state.hsaAmount,
                lsaAmount: this.state.lsaAmount
            },
            'spendingAccounts',
            false
        );
    };

    render() {
        const styles = {
            form: {
                display: 'flex',
                flexDirection: 'column'
            },
            stepperBtnContainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '20px'
            },
            stepperNextBtn: {
                float: 'right',
                marginRight: '5px !important'
            }
        };

        return (
            <div>
                <Text largest bold margin="0 0 10px 0">{ i18n.t(tokens.titles.spendingAccounts) }</Text>

                <div style={styles.form}>
                    <Tip
                        left
                        show={ this.props.tips.spendingAccountBreakdown }
                        close={ () => this.props.hideTip('spendingAccountBreakdown') }
                        customStyle={{ marginTop: -90 }}
                    >
                        { i18n.t(tokens.labels.signup.thisSectionIsFor) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.settingTheMaximums) }</span> { i18n.t(tokens.labels.signup.ofYourPooledSpendingAccounts)}.&nbsp;
                        { i18n.t(tokens.labels.signup.divideTotalAmountsBetweenHSAAndLSA) }.&nbsp;
                        <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.thisCannotBeChangedLater)}.</span>
                    </Tip>

                    <Text small margin="0 0 10px 0">{ i18n.t(tokens.labels.spendingAccounts.pooledSpendingAccountNote) }</Text>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Text bold small margin="0 5px 0 0">{ i18n.t(tokens.labels.spendingAccounts.amountAvailable) } </Text>
                        <Text bold small>{ `$${ numberWithCommas(this.state.amountAvailable.toFixed(2)) }` }</Text>
                    </div>

                    <Tip
                        right
                        show={ this.props.tips.hsaBreakdown }
                        close={ () => this.props.hideTip('hsaBreakdown') }
                    >
                        { i18n.t(tokens.labels.signup.yourHealthSpendingAccountHSAIsA) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.coverage.nonTaxable).toLowerCase() }</span> { i18n.t(tokens.labels.signup.benefitItsUsedTo) }:&nbsp;
                        <li>{ i18n.t(tokens.labels.signup.topOffServiceLessThan100) }</li>
                        <li>{ i18n.t(tokens.labels.signup.coverCostsNotCoveredOnYourPlan) }</li>
                        <li>{ i18n.t(tokens.labels.signup.payForServicesThatHitMaximums) }</li>
                    </Tip>

                    <NumberInput
                        label={ i18n.t(tokens.labels.spendingAccounts.healthSpendingMaximum) }
                        prefix="$"
                        value={Number(this.state.hsaAmount)}
                        onBlur={this._onBlur}
                        onChange={(e) => this._handleHsaChange(e.target.value)}
                        error={ this.state.hsaAmountError }
                        fullWidth
                    />

                    <NumberInput
                        label={ i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingMaximum) }
                        prefix="$ "
                        value={Number(this.state.lsaAmount)}
                        onBlur={this._onBlur}
                        onChange={(e) => this._handleLsaChange(e.target.value)}
                        error={ this.state.lsaAmountError }
                        fullWidth
                    />

                    {
                        this.props.initData.lsaItems &&
                            <div
                                onClick={() => this.setState({ showLsaItemsModal: true })}
                                style={{ cursor: 'pointer' }}
                            >
                                <Text tiny>{ i18n.t(tokens.labels.spendingAccounts.whatAmEligibleFor) } </Text>
                            </div>
                    }

                    {
                        this.state.showLsaItemsModal &&
                            <LsaCategoriesModal
                                open={ this.state.showLsaItemsModal }
                                items={ this.props.initData.lsaItems }
                                whitelabel={ this.props.whitelabel || {} }
                                close={ () => {
                                    this.setState({ showLsaItemsModal: false });
                                }}
                                hideDisabledLsaItems={true}
                            />
                    }

                    {
                        this.props.initData.isProrated &&
                        <>
                            <Text small margin="10px 0 20px 0">
                                { i18n.t(tokens.labels.spendingAccounts.prorationPolicyNote, { proratedBy: localizationMaps.fromEnglish("proratingPeriod", this.props.initData.proratedBy) })}
                            </Text>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Text bold small margin="0 5px 0 0">{ i18n.t(tokens.labels.spendingAccounts.proratedHealthSpendingBalance) }</Text>
                                <Text bold small>{ `$${ numberWithCommas(Math.ceil(this.state.proratedHsa)) }` }</Text>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Text bold small margin="0 5px 0 0">{ i18n.t(tokens.labels.spendingAccounts.proratedLifestyleSpendingBalance) }</Text>
                                <Text bold small>{ `$${ numberWithCommas(Math.ceil(this.state.proratedLsa)) }` }</Text>
                            </div>
                        </>
                    }

                    {
                        this.props.initData.isQuarterlyAllowance &&
                            <Text small margin="10px 0 20px 0">
                                { i18n.t(tokens.labels.spendingAccounts.quarterlyAllowanceNote) }
                            </Text>
                    }

                    <Tip
                        left
                        show={ this.props.tips.lsaBreakdown }
                        close={ () => this.props.hideTip('lsaBreakdown') }
                        customStyle={{ marginTop: 150 }}
                    >
                        { i18n.t(tokens.labels.signup.yourLifestyleSpendingAccountLSAIsA) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.coverage.taxable).toLowerCase() }</span>&nbsp;
                        { i18n.t(tokens.labels.signup.benefitAndWillCountAs) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.incomeEarned) }</span> { i18n.t(tokens.labels.signup.duringTaxSeason) }.&nbsp;
                        { i18n.t(tokens.labels.signup.youCanUseThisBenefitTo) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.buyHealthGoodsAndServices) }</span>&nbsp;
                        { i18n.t(tokens.labels.signup.specifiedByEmployerNotIncludedInHealthPlan) }.
                    </Tip>

                    <div style={styles.stepperBtnContainer}>
                        <Button
                            customStyle={styles.stepperNextBtn}
                            onClick={this._next}
                            color="primary"
                        >
                            { i18n.t(tokens.buttons.continue) }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    hsaAmount: state.signup.spendingAccounts.hsaAmount,
    lsaAmount: state.signup.spendingAccounts.lsaAmount
});

export default connect(mapStateToProps)(SpendingAccounts);